import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';
import { debounce } from 'lodash';

import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME } from 'Common/FormEnum';
import { LetterHistoryReportFieldEnum as Fields } from 'Common/FieldEnum';
import {
  fetchStudents,
  clearStudents,
} from '../state/letterhistoryreport/actions';
import { SiteComponent } from 'Common/SiteComponent';
import StudentTable from './StudentTable';
import { toastError } from 'Common/ToastHelper';
import { StatusOptions } from '../constants';

class LetterHistoryReportFormContainer extends Component {
  state = { studentTableState: '' };

  loadStudentTable = debounce(
    () => {
      if (!this.props.selectedSiteId) {
        return toastError('Select a site');
      }

      const params = {
        studentTableState: this.state.studentTableState,
        selectedSiteId: this.props.selectedSiteId,
        selectedStatuses: this.props.selectedStatuses,
        fromDate: this.props.fromDate,
        toDate: this.props.toDate,
        selectedLetters: this.props.selectedLetters,
      };
      this.props.fetchStudents(params);
    },
    500,
    { leading: true, maxWait: 2000 }
  );

  componentDidUpdate(prevProps, prevState) {
    const {
      selectedStatuses,
      fromDate,
      toDate,
      selectedLetters,
      selectedSiteId,
    } = this.props;
    if (prevProps.selectedSiteId !== this.props.selectedSiteId) {
      this.props.resetSection([Fields.StudentIdSeeds]);
      this.loadStudentTable();
    }

    if (selectedSiteId) {
      if (
        (selectedStatuses &&
          prevProps.selectedStatuses.length !== selectedStatuses.length) ||
        (prevProps.fromDate !== fromDate && fromDate.length === 10) ||
        (prevProps.toDate !== toDate && toDate.length === 10) ||
        (selectedLetters &&
          prevProps.selectedLetters.length !== selectedLetters.length)
      ) {
        this.loadStudentTable();
      }
    }

    if (prevState.studentTableState !== this.state.studentTableState) {
      // when the table state is set the first time we don't want to load any data.
      if (!prevState.studentTableState) {
        return;
      }

      this.loadStudentTable();
    }
  }

  render() {
    const { loading } = this.props;

    return (
      <Fragment>
        <Form name={LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <SiteComponent
                  name={Fields.SiteId}
                  isForm={true}
                  isPrimary={false}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={5}>
                <Field
                  label={'From Date'}
                  name={Fields.FromDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                  maxDate={moment()}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                <Field
                  label={'To Date'}
                  name={Fields.ToDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                  maxDate={moment()}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  multiple
                  selectAllButton
                  selectNoneButton
                  label={'Letter Type'}
                  name={Fields.LetterTemplateIds}
                  component={SelectField}
                  options={this.props.letterTemplates}
                  loading={this.props.templateLoading}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  multiple
                  selectAllButton
                  selectNoneButton
                  label={'Status'}
                  name={Fields.Statuses}
                  component={SelectField}
                  options={StatusOptions}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row style={{ marginTop: '45px' }}>
              <Grid.Column>
                <Field
                  component={StudentTable}
                  name={Fields.StudentIdSeeds}
                  fetchData={(tableState) => {
                    this.setState({ studentTableState: tableState });
                  }}
                  data={this.props.students}
                  loading={this.props.studentsLoading}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (moment(values[Fields.ToDate]).isBefore(moment(values[Fields.FromDate]))) {
    errors[Fields.ToDate] = 'To Date must be after From Date.';
  }
  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.SiteId]) {
    errors[Fields.SiteId] = 'Site must be set.';
  }
  if (values[Fields.LetterTemplateIds].length === 0) {
    errors[Fields.LetterTemplateIds] = 'Letter Type must be set.';
  }
  if (!values[Fields.StudentIdSeeds].length) {
    errors[Fields.StudentIdSeeds] = 'At least one Student must be selected.';
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    students: state.LetterHistoryReportState.letterhistoryreport.students,
    studentsLoading:
      state.LetterHistoryReportState.letterhistoryreport.studentsLoading,
    selectedSiteId:
      state.form[LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME].values[
        Fields.SiteId
      ],
    templateLoading:
      state.LetterHistoryReportState.letterhistoryreport.templateLoading,
  };
};

const PointOfSaleModeForm = reduxForm({
  form: LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(mapStateToProps, {
      fetchStudents,
      clearStudents,
    })(LetterHistoryReportFormContainer)
  )
);

export default PointOfSaleModeForm;



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/components/PointOfSaleModeForm.js